import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Landing from "./pages/Landing";
import Payment from "./pages/Payment";
import PaymentReturn from "./pages/PaymentReturn";
import Dashboard from "./pages/Dashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";
import AgentLogin from "./pages/AgentLogin";
import AgentPanel from "./pages/AgentPanel";
import ClientDetail from "./pages/ClientDetail";
import ManagerLogin from "./pages/ManagerLogin";
import ManagerPanel from "./pages/ManagerPanel";
import AppDownload from "./pages/AppDownload";
import Enroll from "./pages/Enroll";
import AuthCallback from "./pages/AuthCallback";
import ActivationSuccess from "./pages/ActivationSuccess";
import FBPageViewTracker from "./lib/FBPageViewTracker";
import { Toaster } from "./components/ui/toaster";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Detect Emergent Auth callback synchronously during render (before any routing)
  // The session_id is appended to the redirect URL as a hash fragment
  if (typeof window !== "undefined" && location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <FBPageViewTracker />
      <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/enroll" element={<Enroll />} />
      <Route path="/packages" element={<Navigate to="/enroll" replace />} />
      <Route path="/products" element={<Navigate to="/enroll" replace />} />
      <Route path="/onboarding" element={<Navigate to="/enroll" replace />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/payment-return" element={<PaymentReturn />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/activation-success" element={<ActivationSuccess />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/panel" element={<AdminPanel />} />
      <Route path="/agent" element={<AgentLogin />} />
      <Route path="/agent/panel" element={<AgentPanel />} />
      <Route path="/agent/client/:clientId" element={<ClientDetail />} />
      <Route path="/manager" element={<ManagerLogin />} />
      <Route path="/manager/panel" element={<ManagerPanel />} />
      <Route path="/app" element={<AppDownload />} />
      <Route path="/download" element={<AppDownload />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
